function History() {
    return (
      <div className="History main-page">
        <p>Snowblossom was started in 2018 by Joseph Gleason (Fireduck). The objective was to start from a fresh code base rather than a fork of existing projects and avoid some of the mistakes of Bitcoin.</p>
      </div>
    );
  }
  
  export default History;